<script setup>

</script>

<template>
<section>
  <img nopointer noselect src="/images/preservicios.jpg" alt="">
  <div nopointer noselect class="preservicios-post" flex flex-center>
    <div nopointer noselect class="info" flex flex-center flex-column gapped>
      <b nopointer noselect>Sea cual sea tu motivo</b>
      <p nopointer noselect>Te podemos ayudar a optimizar cada metro y diseñar espacios que te representen al 100%, en un proceso efectivo y amigable.</p>
    </div>
  </div>
</section>
</template>

<style scoped lang="scss">
img {
  width: 100%;
  height: 400px;

  object-fit: cover;
}

section {
  position: relative;
  height: 400px !important;
  min-height: unset !important;
}

.preservicios-post {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 400px;

  padding: 2em;

  .info {
    background: rgba(255, 255, 255, 0.2); /* White with transparency */
    backdrop-filter: blur(40px);
    padding: 3em;

    max-width: 90%;

    b {
      background: white;
      padding: .5em;
      text-align: center;
    }

    p {
      text-align: center;
      font-weight: normal;
      color: white;
      width: 400px;
      max-width: 90%;
    }
  }
}
</style>